import styled from 'styled-components';
import { spacing } from '@comicrelief/component-library';

const Content = styled.article`
  background-color: ${({ theme }) => theme.color('grey_light')};
  width: 100%;
  padding: 4rem 1rem;

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: 4rem 2rem;
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding: 4rem;
  }  
`;

const Section = styled.section`
  // TODO: In this ticket (ENG-5074), Curtis has mentioned that this should be the standard 
  // for all components, so will be set in a reusable, CL-based variable at some point soon:
  max-width: 1152px;
  padding: 0 0 ${spacing('xl')};
  margin: 0 auto;

  > article:not(:last-child) {
    margin-bottom: ${spacing('l')};
  }
`;

export { Content, Section };
